import { motion } from "framer-motion";
import { Chrome } from "lucide-react";

export function ChromeExtension() {
  return (
    <main className="min-h-screen flex items-center justify-center">
      <div className="max-w-2xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="space-y-6"
        >
          <Chrome className="w-16 h-16 text-purple-400 mx-auto" />
          <h1 className="text-4xl md:text-6xl font-bold tracking-tight bg-gradient-to-r from-white to-neutral-400 bg-clip-text text-transparent">
            Coming Soon
          </h1>
          <p className="text-xl text-neutral-300">
            Our Chrome extension is currently under development. Stay tuned for updates!
          </p>
          <div className="pt-8">
            <a
              href="/"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/15 backdrop-blur-sm px-6 py-3 rounded-full transition-all duration-300"
            >
              Return to Home
            </a>
          </div>
        </motion.div>
      </div>
    </main>
  );
} 